
var Slider = {

    init : function () {
        $('.o-slider').each(function () {
            if (typeof ($('.o-slider')) !== 'undefined' && $('.o-slider').length !== 0) {
                var slidesToShowData = $(this).data('nr-of-slides');
                var slidesToShowDataResponsive1 = $(this).data('nr-of-slides-responsive-1');
                var slidesToShowDataResponsive2 = $(this).data('nr-of-slides-responsive-2');
                var slidesToShowDataResponsive3 = $(this).data('nr-of-slides-responsive-3');

                var dotsData = $(this).data('dots');
                // var arrowsData = $(this).data('arrow');
                var autoplayData = $(this).data('autoplay');
                var autoplaySpeed = $(this).data('autoplay-speed');
                var slidesToScroll = $(this).data('slides-to-scroll');
                var slidesToScrollResponsive1 = $(this).data('slides-to-scroll-responsive-1');
                var slidesToScrollResponsive2 = $(this).data('slides-to-scroll-responsive-2');
                var slidesToScrollResponsive3 = $(this).data('slides-to-scroll-responsive-3');

                $(this).slick({
                    slidesToShow: slidesToShowData,
                    dots: dotsData,
                    // dotsClass: 'c-icon c-icon--type-svg-hexagon c-icon--size-xs c-icon--theme-grayscale-2',
                    arrows: false,
                    prevArrow: '<button type="button" class="slick-prev pull-left"></button>',
                    nextArrow: '<button type="button" class="slick-next pull-right"></button>',
                    autoplay: autoplayData,
                    autoplaySpeed: autoplaySpeed,
                    pauseOnHover: false,
                    adaptiveHeight: false,
                    slidesToScroll: slidesToScroll,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: slidesToShowDataResponsive1,
                                slidesToScroll: slidesToScrollResponsive1,
                            },
                        },
                        {
                        breakpoint: 600,
                            settings: {
                                slidesToShow: slidesToShowDataResponsive2,
                                slidesToScroll: slidesToScrollResponsive2,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: slidesToShowDataResponsive3,
                                slidesToScroll: slidesToScrollResponsive3,
                            },
                        },
                    ],
                });
            }
        });
    },
}

export default Slider;



// WEBPACK FOOTER //
// ./scripts/modules/slider.js